// ============================================================
// useEsignPilot.ts — B4c: is the firm's e-signature pilot on? (GET
// /api/auth/me → authUser.firmEsignPilot). Off / missing → nothing about
// e-signature (signing, the mobile numbers codes go to) shows anywhere.
// ============================================================
import { useCasevoStore } from '../store/useCasevoStore'

export const useEsignPilot = (): boolean => useCasevoStore((s) => s.authUser?.firmEsignPilot === true)
